import React, { useEffect, useState } from "react"
import { Col, Row } from "react-bootstrap"
import Select from "react-select"
import Navbar from "../../../Components/Navbar/Navbar"
import Table from "../../../Components/TableTemplate/Table"
import moment from "moment"
import {
  numberFormat,
  selectDropdownStyle,
  toastStyle,
  refreshPage,
} from "../../../Helpers/Utils/Common"
import toast from "react-hot-toast"
import DatePicker from "react-datepicker"
import Moment from "moment"
import * as XLSX from "xlsx"
import ElmhurstLogo from "../../../Assets/Images/elmhurst-initial-logo.png"
import cleanLogo from "../../../Assets/Images/Login/transparent_bg.png"

import { searchWastage } from "../../../Helpers/apiCalls/Reports/DailyWastageApi"
import { getAllItems } from "../../../Helpers/apiCalls/itemsApi"

import downloadIcon from "../../../Assets/Images/download_icon.png"
import SupplierPriceTable from "../../../Components/Table/SupplierPriceTable"
import { getBrand } from "../../../Helpers/apiCalls/brandsApi"
import { getAllSuppliers } from "../../../Helpers/apiCalls/suppliersApi"
import { getSupplierPrices } from "../../../Helpers/apiCalls/Reports/SupplierPrice"
import NoDataPrompt from "../../../Components/NoDataPrompt/NoDataPrompt"
import ApproveModal from "../../../Components/Modals/ApproveModal"
import Footer from "../../../Components/Footer/Footer"

export default function SupplierPriceReport() {
  const [inactive, setInactive] = useState(true)
  const date = new Date()
  date.setDate(date.getDate() - 7)
  const today = Moment().format("MM/DD/YYYY")
  const [filterConfig, setFilterConfig] = useState({
    brand_id: "",
    supplier_id: "",
    item_id: "",
    // date_from: new Date(date),
    // date_to: new Date(today),
  })
  const [isClicked, setIsClicked] = useState(false)
  const [showLoader, setShowLoader] = useState(false)
  const [tableData, setTableData] = useState([])
  const [items, setItems] = useState([])
  const [brand, setBrand] = useState([])
  const [suppliers, setSuppliers] = useState([])
  const xlsxHeaders = ["SUPPLIER", "ITEM", "UNIT", "DATE", "PRICE"]
  const [excelData, setExcelData] = useState([])
  /* print modal handler */
  const [showPrintModal, setShowPrintModal] = useState(false)
  const handleShowPrintModal = () => setShowPrintModal(true)
  const handleClosePrintModal = () => setShowPrintModal(false)

  // SEARCH USER
  function handleOnSearch(e) {
    const { name, value } = e.target
    setFilterConfig((prev) => {
      return { ...prev, [name]: value }
    })
  }

  async function fetchAllItems() {
    const response = await getAllItems()

    if (response.response.data) {
      var data = response.response.data.map((item) => {
        var info = item
        info.label = item.name
        info.value = item.id
        return info
      })
      setItems(data)
    } else {
    }
  }

  async function fetchData() {
    setShowLoader(true)
    setTableData([])

    const response = await getSupplierPrices(filterConfig)
    if (response.data) {
      var allBills = response.data.data.map((bill) => {
        var info = bill
        info.date = Moment(bill.added_on).format("MMM DD, YYYY")
        return info
      })
      setTableData(allBills)

      var excel = allBills.map((bill) => {
        var info = {}
        info.supplier = bill.supplier
        info.name = bill.name
        info.unit = bill.unit
        info.date = bill.date
        info.price = bill.price
        return info
      })
      setExcelData(excel)
    }
    setShowLoader(false)
  }

  async function fetchBrands() {
    const response = await getBrand({})
    if (response.data) {
      var brands = response.data.data.map((brand) => {
        var info = {}
        info.name = "brand"
        info.value = brand.id
        info.label = brand.name
        info.id = brand.id
        info.selected_value_name = "selected_brand"
        return info
      })
      setBrand(brands)
    }
  }

  async function fetchSuppliers() {
    setSuppliers([])
    const response = await getAllSuppliers()
    if (response.data) {
      var suppliers = response.data.data.map((supllier) => {
        var info = {}
        info.name = "supllier"
        info.value = supllier.id
        info.label = supllier.trade_name
        info.id = supllier.id
        info.selected_value_name = "selected_supllier"
        return info
      })
      setSuppliers(suppliers)
    }
  }

  // FUNCTION FOR EXPORT
  function handleExport() {
    const rows = excelData
    const header = ["", ""]
    const meta = [
      ["REPORT TITLE:", "SUPPLIER PRICE REPORT"],
      [
        "ITEM:",
        filterConfig.item_name !== "" && filterConfig.item_name !== undefined
          ? filterConfig.item_name
          : "All Items",
      ],
      [
        "BRAND:",
        filterConfig.brand_name !== "" && filterConfig.brand_name !== undefined
          ? filterConfig.brand_name
          : "All Brands",
      ],
      [
        "SUPPLIER:",
        filterConfig.supplier_name !== "" &&
        filterConfig.supplier_name !== undefined
          ? filterConfig.supplier_name
          : "All Suppliers",
      ],
    ]

    const sheet = XLSX.utils.json_to_sheet([{}], {
      header: header,
    })

    /* generate worksheet and workbook */
    const workbook = XLSX.utils.book_new()
    XLSX.utils.sheet_add_json(sheet, rows, { origin: "A6" })
    XLSX.utils.book_append_sheet(workbook, sheet, "Sheet 1")
    XLSX.utils.sheet_add_aoa(sheet, meta, { origin: "A1" })
    XLSX.utils.sheet_add_aoa(sheet, [xlsxHeaders], { origin: "A6" })
    XLSX.writeFile(
      workbook,
      `SupplierPriceReport (${Moment().format("MMM DD, YYYY")}).xlsx`,
      { compression: true }
    )
  }

  async function handlePrintPI() {
    setIsClicked(true)
    toast.loading("Printing...", { style: toastStyle() })
    handleClosePrintModal()
    setTimeout(() => {
      toast.dismiss()
      Print()
    }, 1000)
  }

  function Print() {
    let printContents = document.getElementById("printablediv").innerHTML
    let originalContents = document.body.innerHTML
    document.body.innerHTML = printContents
    window.print(printContents)
    document.body.innerHTML = originalContents
    refreshPage()
  }

  useEffect(() => {
    fetchAllItems()
    fetchBrands()
    fetchSuppliers()
  }, [])

  useEffect(() => {
    if (
      filterConfig.brand_id !== "" ||
      filterConfig.supplier_id !== "" ||
      filterConfig.item_id !== ""
    ) {
      fetchData()
    }
  }, [filterConfig])

  return (
    <div>
      <div className="page">
        <Navbar
          onCollapse={(inactive) => {
            setInactive(inactive)
          }}
          active={"DS REPORTS"}
        />
      </div>

      <div className={`manager-container ${inactive ? "inactive" : "active"}`}>
        <Row className="mb-4">
          <Col xs={12} lg={7}>
            <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2">
              {" "}
              SUPPLIER PRICE REPORTS{" "}
            </h1>
          </Col>
          <Col
            xs={12}
            lg={5}
            className="d-flex justify-content-end force-width flex-column flex-lg-row gap-3"
          >
            <input
              type="search"
              name="branch_name"
              placeholder="Search branch name"
              className="search-bar"
              onChange={handleOnSearch}
            />
          </Col>
        </Row>

        <div className="tab-content supplier-price">
          <div className="mb-3" />
          <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
            Filter By:
          </span>
          <Row className="PO-filters flex flex-row mx-2 my-1">
            <Col xs={6} lg={4} className="mb-2 mb-lg-0">
              <Select
                className="dropsearch-filter"
                classNamePrefix="react-select"
                placeholder="Select Item"
                styles={selectDropdownStyle}
                options={items}
                onChange={(e) => {
                  setFilterConfig((prev) => {
                    return {
                      ...prev,
                      item_id: e.value,
                      item_name: e.label !== "All Items" ? e.label : "",
                    }
                  })
                }}
              />
            </Col>
            <Col xs={6} lg={4} className="mb-2 mb-lg-0">
              <Select
                className="dropsearch-filter"
                classNamePrefix="react-select"
                placeholder="Select Brand"
                styles={selectDropdownStyle}
                value={filterConfig.selected_brand}
                options={brand}
                onChange={(e) => {
                  setFilterConfig((prev) => {
                    return {
                      ...prev,
                      brand_id: e.value,
                      brand_name: e.label,
                      selected_brand: {
                        value: e.value,
                        label: e.label,
                      },
                    }
                  })
                }}
              />
            </Col>
            <Col xs={12} lg={4} className="mb-2 mb-lg-0">
              <Select
                className="dropsearch-filter"
                classNamePrefix="react-select"
                placeholder="Select Supplier"
                styles={selectDropdownStyle}
                value={filterConfig.selected_supplier}
                options={suppliers}
                onChange={(e) => {
                  setFilterConfig((prev) => {
                    return {
                      ...prev,
                      supplier_id: e.value,
                      supplier_name: e.label,
                      selected_supplier: {
                        value: e.value,
                        label: e.label,
                      },
                    }
                  })
                }}
              />
            </Col>
          </Row>
          <div className="mb-2" />

          <div className="edit-purchased-items m-3 p-2">
            {tableData?.length > 0 ? (
              <SupplierPriceTable tableData={tableData} />
            ) : (
              <NoDataPrompt />
            )}
          </div>
          <div className="mb-2" />
        </div>
        <br />
        <Row className="mb-4">
          <Col xs={12} lg={8}></Col>
          <Col xs={12} lg={2} className="mt-4 mt-lg-0">
            <div className="PO-filters">
              <button
                className="button-secondary p-2 p-lg-1 w-100 fs-6"
                onClick={() => handleShowPrintModal()}
              >
                Print
              </button>
            </div>
          </Col>
          <Col xs={12} lg={2} className="mt-1 mt-lg-0">
            <div className="PO-filters">
              <button
                type="button"
                className="primary-btn"
                onClick={handleExport}
              >
                <span className="me-2">
                  <img
                    alt="download"
                    width={20}
                    height={20}
                    src={downloadIcon}
                  ></img>
                </span>
                Download
              </button>
            </div>
          </Col>
        </Row>
        <br />
      </div>

      {/* PRINT VIEW */}
      <div className="print-container px-3 py-2 display-none" id="printablediv">
        <div className="text-end print-header d-flex flex-column">
          <span className="text-uppercase">
            {moment().format("MMM DD, yyyy")}
          </span>
        </div>
        <div className="print-header-invoice-elm">
          <div className="print-top d-flex justify-content-center py-1 mt-5">
            <img src={ElmhurstLogo} className="print-logo-elm" alt="" />
          </div>
          <div className="print-top">
            <h5 className="print-shop-header-elm d-flex justify-content-center">
              497 D Molave Extension, Lahug, Cebu City
            </h5>
            <br />
            <h2 className="delivery-title-elm d-flex justify-content-center">
              SE PURCHASE INVOICE
            </h2>
            {/* <h5 className="print-shop-header fs-4 d-flex justify-content-center">STATEMENT OF ACCOUNT</h5> */}
          </div>
        </div>
        <div className="print-body mt-5">
          <Row>
            <Col>
              <div className="d-flex my-2 align-items-center ms-5">
                <Col xs={1} className="print-label">
                  Item:
                </Col>
                <Col xs={5} className="print-data">
                  {filterConfig.item_name
                    ? filterConfig.item_name
                    : "All Items"}
                </Col>
              </div>
              <div className="d-flex my-2 align-items-center ms-5">
                <Col xs={1} className="print-label">
                  Brand:
                </Col>
                <Col xs={5} className="print-data">
                  {filterConfig.brand_name
                    ? filterConfig.brand_name
                    : "All Brands"}
                </Col>
              </div>
              <div className="d-flex my-2 align-items-center ms-5">
                <Col xs={1} className="print-label">
                  Supplier:
                </Col>
                <Col xs={5} className="print-data">
                  {filterConfig.supplier_name
                    ? filterConfig.supplier_name
                    : "All Suppliers"}
                </Col>
              </div>
            </Col>
          </Row>
        </div>

        <div className="edit-purchased-items m-3 p-2">
          {tableData?.length > 0 ? (
            <SupplierPriceTable tableData={tableData} />
          ) : (
            <NoDataPrompt />
          )}
        </div>
      </div>

      <ApproveModal
        show={showPrintModal}
        hide={() => handleClosePrintModal()}
        type="print"
        text="print this supplier price report"
        handler={() => handlePrintPI()}
        isClicked={isClicked}
      />
      <Footer />
    </div>
  )
}
